var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/shared/UpsellWrapper/UpsellWrapper.jsx";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable no-confusing-arrow */

/* eslint-disable zillow/react/no-danger */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import styled, { css } from 'styled-components';
import { Button, Heading, Upsell, Text, StyledHeading, StyledText, Spacer, Tag, ButtonGroup, TextButton, CloseButton, MediaObject, StyledTextButton, spaceMixin, StyledButton } from '@zillow/constellation';
import { useYieldCallback } from '@zillow/yield-callback';
import { NewLaneEvent } from '../../../eventing/NewLaneEvent';
import { formNewLaneEventPayload } from '../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../eventing/clickStreamEventSchema';
import { DSP_BRAND, DSP_EXPERIENCE } from '../../internal/constants';
import OmpIcon from '../../internal/DisplayIcon/OmpIcon';
import { useOnsiteMessagingImpressionEvent } from '../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingImpressionEvent';
import { useOnsiteMessagingIntentToShowEvent } from '../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingIntentToShowEvent';
import { NBANewLaneEvent } from '../../../eventing/NBANewLaneEvent';
import { formNBANewLaneEventPayload } from '../../../eventing/nbaNewLaneEventPayload';
import { NBA_CLICKSTREAM_EVENT_TYPE } from '../../../eventing/nbaClickstreamEventSchema';

var showBodyCSS = function showBodyCSS(_ref) {
  var showBody = _ref.showBody;
  return css(["", " + ", "{display:", ";}"], StyledHeading, StyledText, showBody ? 'initial' : 'none');
};

var hideBorderCss = css(["box-shadow:none;border:none;"]);
var StyledUpsell = styled(Upsell).withConfig({
  displayName: "UpsellWrapper__StyledUpsell",
  componentId: "tpnuef-0"
})(["margin:", ";", ";"], function (_ref2) {
  var overrideMargin = _ref2.overrideMargin;
  return "" + overrideMargin || "0px 16px 0px 16px";
}, function (_ref3) {
  var hasBorder = _ref3.hasBorder;
  return hasBorder ? null : hideBorderCss;
});
var SecondaryTextButton = styled(StyledTextButton).withConfig({
  displayName: "UpsellWrapper__SecondaryTextButton",
  componentId: "tpnuef-1"
})(["margin:0 0 0 ", " !important;"], spaceMixin('sm'));
var SecondaryButton = styled(StyledButton).withConfig({
  displayName: "UpsellWrapper__SecondaryButton",
  componentId: "tpnuef-2"
})(["margin:0 0 0 ", " !important;"], spaceMixin('sm'));
/* eslint-disable zillow/react/prop-types */

var renderLayout = function renderLayout(_ref4) {
  var actionButton = _ref4.actionButton,
      secondaryActionButton = _ref4.secondaryActionButton,
      body = _ref4.body,
      closeable = _ref4.closeable,
      direction = _ref4.direction,
      heading = _ref4.heading,
      media = _ref4.media,
      onClose = _ref4.onClose;
  var align = 'start';

  if (direction === 'column') {
    align = 'center';
  }

  var close;

  if (closeable) {
    close = /*#__PURE__*/React.createElement(CloseButton, {
      onClick: onClose,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 17
      }
    });
  } // Handles dual CTA scenario


  var action;

  if (Object.keys(actionButton === null || actionButton === void 0 ? void 0 : actionButton.props).length > 0 && Object.keys(secondaryActionButton === null || secondaryActionButton === void 0 ? void 0 : secondaryActionButton.props).length > 0) {
    var primaryAction = /*#__PURE__*/React.createElement(Button, _extends({}, actionButton.props, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 87,
        columnNumber: 31
      }
    }));
    var secondaryAction = /*#__PURE__*/React.createElement(SecondaryTextButton, _extends({}, secondaryActionButton.props, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 31
      }
    }));

    if ((secondaryActionButton === null || secondaryActionButton === void 0 ? void 0 : secondaryActionButton.props.role) === 'button') {
      secondaryAction = /*#__PURE__*/React.createElement(SecondaryButton, _extends({}, secondaryActionButton.props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 90,
          columnNumber: 31
        }
      }));
    }

    action = /*#__PURE__*/React.createElement(ButtonGroup, {
      "aria-label": "Dual CTAs Actions",
      marginTop: "xs",
      marginBottom: "xs",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 13
      }
    }, primaryAction, secondaryAction);
  } else if (Object.keys(actionButton === null || actionButton === void 0 ? void 0 : actionButton.props).length > 0) {
    action = /*#__PURE__*/React.createElement(TextButton, _extends({}, actionButton.props, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 18
      }
    }));
  }

  return /*#__PURE__*/React.createElement(MediaObject, {
    media: media,
    direction: direction,
    align: align,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 9
    }
  }, heading, body, action, close);
};
/* When rendering the `ADVERTISEMENT` tag marketing is needing to be compliant, we
are using the below `StyledTag` with `position:absolute` to keep the text top right */


var StyledTag = styled(Tag).withConfig({
  displayName: "UpsellWrapper__StyledTag",
  componentId: "tpnuef-3"
})(["background:none;position:absolute;max-width:220px;height:14px;top:8px;right:8px;text-align:right;"]);
var StyledImage = styled.img.withConfig({
  displayName: "UpsellWrapper__StyledImage",
  componentId: "tpnuef-4"
})(["height:auto;width:127px;max-width:100%;"]);
var UpsellWrapper = styled(function (_ref5) {
  var actionButton = _ref5.actionButton,
      actionButtonType = _ref5.actionButtonType,
      actionLink = _ref5.actionLink,
      actionText = _ref5.actionText,
      actionType = _ref5.actionType,
      secondaryActionButton = _ref5.secondaryActionButton,
      secondaryActionButtonType = _ref5.secondaryActionButtonType,
      secondaryActionLink = _ref5.secondaryActionLink,
      secondaryActionText = _ref5.secondaryActionText,
      secondaryActionType = _ref5.secondaryActionType,
      advertisementTag = _ref5.advertisementTag,
      background = _ref5.background,
      bodyMarkdownText = _ref5.bodyMarkdownText,
      closeable = _ref5.closeable,
      eventData = _ref5.eventData,
      newLaneEventData = _ref5.newLaneEventData,
      additionalClickStreamData = _ref5.additionalClickStreamData,
      headingMarkdownText = _ref5.headingMarkdownText,
      icon = _ref5.icon,
      iconFontColor = _ref5.iconFontColor,
      imageSize = _ref5.imageSize,
      media = _ref5.media,
      mediaQuery = _ref5.mediaQuery,
      onAction = _ref5.onAction,
      onSecondaryAction = _ref5.onSecondaryAction,
      onClose = _ref5.onClose,
      showBody = _ref5.showBody,
      showAdvertisement = _ref5.showAdvertisement,
      tagInput = _ref5.tagInput,
      adTagImage = _ref5.adTagImage,
      overrideMargin = _ref5.overrideMargin,
      hasBorder = _ref5.hasBorder,
      gaImpressionCategory = _ref5.gaImpressionCategory,
      gaImpressionAction = _ref5.gaImpressionAction,
      gaImpressionLabel = _ref5.gaImpressionLabel,
      gaEngagementCategory = _ref5.gaEngagementCategory,
      gaEngagementAction = _ref5.gaEngagementAction,
      gaEngagementLabel = _ref5.gaEngagementLabel,
      gaHoverCategory = _ref5.gaHoverCategory,
      gaHoverAction = _ref5.gaHoverAction,
      gaHoverLabel = _ref5.gaHoverLabel,
      gaEngagementSecondaryCategory = _ref5.gaEngagementSecondaryCategory,
      gaEngagementSecondaryAction = _ref5.gaEngagementSecondaryAction,
      gaEngagementSecondaryLabel = _ref5.gaEngagementSecondaryLabel,
      gaHoverSecondaryCategory = _ref5.gaHoverSecondaryCategory,
      gaHoverSecondaryAction = _ref5.gaHoverSecondaryAction,
      gaHoverSecondaryLabel = _ref5.gaHoverSecondaryLabel,
      gaCloseCategory = _ref5.gaCloseCategory,
      gaCloseAction = _ref5.gaCloseAction,
      gaCloseLabel = _ref5.gaCloseLabel,
      restProps = _objectWithoutProperties(_ref5, ["actionButton", "actionButtonType", "actionLink", "actionText", "actionType", "secondaryActionButton", "secondaryActionButtonType", "secondaryActionLink", "secondaryActionText", "secondaryActionType", "advertisementTag", "background", "bodyMarkdownText", "closeable", "eventData", "newLaneEventData", "additionalClickStreamData", "headingMarkdownText", "icon", "iconFontColor", "imageSize", "media", "mediaQuery", "onAction", "onSecondaryAction", "onClose", "showBody", "showAdvertisement", "tagInput", "adTagImage", "overrideMargin", "hasBorder", "gaImpressionCategory", "gaImpressionAction", "gaImpressionLabel", "gaEngagementCategory", "gaEngagementAction", "gaEngagementLabel", "gaHoverCategory", "gaHoverAction", "gaHoverLabel", "gaEngagementSecondaryCategory", "gaEngagementSecondaryAction", "gaEngagementSecondaryLabel", "gaHoverSecondaryCategory", "gaHoverSecondaryAction", "gaHoverSecondaryLabel", "gaCloseCategory", "gaCloseAction", "gaCloseLabel"]);

  var ref = useOnsiteMessagingImpressionEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingIntentToShowEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData,
    gaEventData: {
      category: gaImpressionCategory,
      action: gaImpressionAction,
      label: gaImpressionLabel
    }
  });
  var onClickAction = useYieldCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'click'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData);

    if (gaEngagementCategory) {
      var gaPayload = {
        category: gaEngagementCategory,
        action: gaEngagementAction,
        label: gaEngagementLabel
      };
      NewLaneEvent(oldDspPayload, newLanePayload, gaPayload);
    } else {
      NewLaneEvent(oldDspPayload, newLanePayload);
    }

    if ((newLaneEventData === null || newLaneEventData === void 0 ? void 0 : newLaneEventData.isNbaProcessed) === true) {
      NBANewLaneEvent(formNBANewLaneEventPayload(NBA_CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, 'click'));
    }

    onAction();

    if (actionLink) {
      window.open(actionLink, '_blank');
    }
  }, [gaEngagementCategory, eventData, newLaneEventData, additionalClickStreamData, onAction, actionLink, gaEngagementAction, gaEngagementLabel]);
  var onClickClose = useYieldCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'close'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.CLOSE, newLaneEventData, additionalClickStreamData);

    if (gaCloseCategory) {
      var gaPayload = {
        category: gaCloseCategory,
        action: gaCloseAction,
        label: gaCloseLabel
      };
      NewLaneEvent(oldDspPayload, newLanePayload, gaPayload);
    } else {
      NewLaneEvent(oldDspPayload, newLanePayload);
    }

    onClose();
  }, [gaCloseCategory, eventData, newLaneEventData, additionalClickStreamData, onClose, gaCloseAction, gaCloseLabel]);
  var onHoverAction = useCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'hover'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.HOVER, newLaneEventData, additionalClickStreamData);

    if (gaHoverCategory) {
      var gaPayload = {
        category: gaHoverCategory,
        action: gaHoverAction,
        label: gaHoverLabel
      };
      NewLaneEvent(oldDspPayload, newLanePayload, gaPayload);
    } else {
      NewLaneEvent(oldDspPayload, newLanePayload);
    }

    if ((newLaneEventData === null || newLaneEventData === void 0 ? void 0 : newLaneEventData.isNbaProcessed) === true) {
      NBANewLaneEvent(formNBANewLaneEventPayload(NBA_CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, 'hover'));
    }
  }, [gaHoverCategory, eventData, newLaneEventData, additionalClickStreamData, gaHoverAction, gaHoverLabel]); // Secondary action

  var onClickSecondaryAction = useYieldCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'secondaryClick'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData, true);

    if (gaEngagementSecondaryCategory) {
      var gaPayload = {
        category: gaEngagementSecondaryCategory,
        action: gaEngagementSecondaryAction,
        label: gaEngagementSecondaryLabel
      };
      NewLaneEvent(oldDspPayload, newLanePayload, gaPayload);
    } else {
      NewLaneEvent(oldDspPayload, newLanePayload);
    }

    onSecondaryAction();

    if (secondaryActionLink) {
      window.open(secondaryActionLink, '_blank');
    }
  }, [gaEngagementSecondaryCategory, eventData, newLaneEventData, additionalClickStreamData, onSecondaryAction, secondaryActionLink, gaEngagementSecondaryAction, gaEngagementSecondaryLabel]);
  var onHoverSecondaryAction = useCallback(function () {
    var oldDspPayload = {
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'secondaryHover'
      }, eventData))
    };
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.HOVER, newLaneEventData, additionalClickStreamData, true);

    if (gaHoverSecondaryCategory) {
      var gaPayload = {
        category: gaHoverSecondaryCategory,
        action: gaHoverSecondaryAction,
        label: gaHoverSecondaryLabel
      };
      NewLaneEvent(oldDspPayload, newLanePayload, gaPayload);
    } else {
      NewLaneEvent(oldDspPayload, newLanePayload);
    }
  }, [gaHoverSecondaryCategory, eventData, newLaneEventData, additionalClickStreamData, gaHoverSecondaryAction, gaHoverSecondaryLabel]);
  var adElement = tagInput;

  if (adTagImage && adTagImage.src) {
    adElement = /*#__PURE__*/React.createElement(StyledImage, {
      alt: adTagImage.alt,
      src: adTagImage.src,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 411,
        columnNumber: 25
      }
    });
  }

  var adTag = showAdvertisement ? /*#__PURE__*/React.createElement(Spacer, {
    paddingBottom: "xs",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 414,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(StyledTag, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 415,
      columnNumber: 17
    }
  }, adElement)) : null;
  var headingNode = headingMarkdownText ? /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 420,
      columnNumber: 13
    }
  }, adTag, /*#__PURE__*/React.createElement(Heading, {
    level: 6,
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(headingMarkdownText)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 422,
      columnNumber: 17
    }
  })) : adTag;
  var bodyNode = bodyMarkdownText ? /*#__PURE__*/React.createElement(Text, {
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(bodyMarkdownText)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 434,
      columnNumber: 13
    }
  }) : null;
  var renderedPrimaryActionButton = /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 441,
      columnNumber: 43
    }
  });

  if (actionButton) {
    renderedPrimaryActionButton = /*#__PURE__*/React.createElement("div", {
      role: "button",
      tabIndex: 0,
      onClick: onClickAction,
      onKeyDown: onClickAction,
      onMouseEnter: onHoverAction,
      buttonType: actionButtonType,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 444,
        columnNumber: 17
      }
    }, actionButton);
  } else if (actionText) {
    renderedPrimaryActionButton = /*#__PURE__*/React.createElement(Button, {
      onClick: onClickAction,
      "data-actiontype": actionType,
      onMouseEnter: onHoverAction,
      buttonType: actionButtonType,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 457,
        columnNumber: 17
      }
    }, actionText);
  }

  var renderedSecondaryActionButton = /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 467,
      columnNumber: 45
    }
  });

  if (secondaryActionButton) {
    renderedSecondaryActionButton = /*#__PURE__*/React.createElement("div", {
      role: "button",
      tabIndex: 0,
      onClick: onClickSecondaryAction,
      onKeyDown: onClickSecondaryAction,
      onMouseEnter: onHoverSecondaryAction,
      buttonType: secondaryActionButtonType,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 470,
        columnNumber: 17
      }
    }, secondaryActionButton);
  } else if (secondaryActionText) {
    renderedSecondaryActionButton = /*#__PURE__*/React.createElement(TextButton, {
      onClick: onClickSecondaryAction,
      "data-actiontype": secondaryActionType,
      onMouseEnter: onHoverSecondaryAction,
      buttonType: secondaryActionButtonType,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 483,
        columnNumber: 17
      }
    }, secondaryActionText);
  }

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 495,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(StyledUpsell, _extends({
    heading: headingNode,
    background: background,
    body: bodyNode,
    actionButton: renderedPrimaryActionButton,
    secondaryActionButton: renderedSecondaryActionButton,
    renderLayout: renderLayout,
    closeable: closeable,
    media: /*#__PURE__*/React.createElement(OmpIcon, {
      icon: icon,
      iconFontColor: iconFontColor,
      imageAlt: media === null || media === void 0 ? void 0 : media.alt,
      imageSrc: media === null || media === void 0 ? void 0 : media.src,
      imageSize: imageSize,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 505,
        columnNumber: 25
      }
    }),
    mediaQuery: mediaQuery,
    onClose: onClickClose,
    overrideMargin: overrideMargin,
    hasBorder: hasBorder,
    showAdvertisement: showAdvertisement,
    tagInput: tagInput
  }, restProps, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 496,
      columnNumber: 17
    }
  })));
}).withConfig({
  displayName: "UpsellWrapper",
  componentId: "tpnuef-5"
})(["", ""], showBodyCSS);
UpsellWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A [`Button`](#/Button%20components?id=button) node used as the primary call to action.
   */
  actionButton: PropTypes.node,

  /**
   * The primary action button type selection.
   */
  actionButtonType: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),

  /**
   * The action link, optional.
   */
  actionLink: PropTypes.string,

  /**
   * The action text displayed in component.
   * */
  actionText: PropTypes.string,

  /**
   * The action type that helps determine the onAction function.
   * */
  actionType: PropTypes.oneOf(['save_search', 'sign_up', 'url_link']),

  /**
   * A [`Button`](#/Button%20components?id=button) node used as the secondary call to action.
   */
  secondaryActionButton: PropTypes.node,

  /**
   * The secondary action button type selection.
   */
  secondaryActionButtonType: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),

  /**
   * The action link, optional.
   */
  secondaryActionLink: PropTypes.string,

  /**
   * The action text displayed in component.
   * */
  secondaryActionText: PropTypes.string,

  /**
   * The action type that helps determine the onAction function.
   * */
  secondaryActionType: PropTypes.oneOf(['save_search', 'sign_up', 'url_link']),

  /**
   * The background color.
   * */
  background: PropTypes.oneOf(['backgroundBlue', 'backgroundDarkBlue', 'backgroundWhite', 'blue200']),

  /**
   * The message body displayed in component.
   * */
  bodyMarkdownText: PropTypes.string,

  /**
   * By default, this upsell cannot be closed.
   * Set this to `true` to allow closing of the upsell.
   */
  closeable: PropTypes.bool,

  /**
   * Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  eventData: PropTypes.object,

  /**
   * New Lane Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,

  /**
   * Additional Clickstream data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object,

  /**
   * The message head displayed in component.
   * */
  headingMarkdownText: PropTypes.string,

  /**
   * Icon used in your messaging. Currently 'dollar', 'home', 'logo', 'phone',
   * 'salesign', 'pigggy', 'ZOHome', 'houseWithDollarSign', 'hangingSign',
   * 'testimonialIcon', 'hourglassIcon', 'moneyIcon', "heartHome", "appHome",
   * "calendar" & "comparableHome" are valid.
   * Default icon is a zillow logo.
   * */
  icon: PropTypes.string,

  /**
   * The constellation color code for the icon's drawing color.
   * Available constellation color codes could be found at
   * http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#section-colors
   */
  iconFontColor: PropTypes.string,
  media: PropTypes.shape({
    /**
     * The alt text of the image.
     */
    alt: PropTypes.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: PropTypes.string
  }),

  /**
   * The size of the icon. 'xs', 'sm', 'md', 'lg'.
   */
  imageSize: PropTypes.string,

  /**
   * A [mediaQuery](http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#section-media-queries) object that supports the `showBody` prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mediaQuery: PropTypes.object,

  /**
   * The action on clicking the actionText.
   * */
  onAction: PropTypes.func,

  /**
   * The action on clicking the actionText.
   * */
  onSecondaryAction: PropTypes.func,

  /**
   * The action on clicking the close icon.
   * */
  onClose: PropTypes.func,

  /**
   * When true, the body content will be shown right after heading.
   * You can control this prop with the `mediaQuery` object.
   */
  showBody: PropTypes.bool,

  /**
   * When true, the text within `tagInput` prop will render top right on
   * the component.
   * Default value is false.
   */
  showAdvertisement: PropTypes.bool,

  /**
   * This text will populate in the top right corner of the component.
   * The `showAdvertisement` must be set to true for this to appear. Currently
   * this is set to false by default.
   * Default value is currently 'ADVERTISEMENT'
   */
  tagInput: PropTypes.string,

  /**
   * This image will populate in the top right corner of the component.
   * The `showAdvertisement` must be set to true for this to appear. Currently
   * this is set to false by default.
   */
  adTagImage: PropTypes.shape({
    /**
     * The alt text of the image.
     */
    alt: PropTypes.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: PropTypes.string
  }),

  /**
   * The margin value to adjust spacing around the upsell UI.
   * Enter value in the format: top right bottom left
   * Default value: 0px 16px 0px 16px
   */
  overrideMargin: PropTypes.string,

  /**
   * Whether the message component should come with constellation
   * Upsell's border style. If false, then it won't have any border
   */
  hasBorder: PropTypes.bool,

  /**
   * The impression GA event's category
   */
  gaImpressionCategory: PropTypes.string,

  /**
   * The impression GA event's action
   */
  gaImpressionAction: PropTypes.string,

  /**
   * The impression GA event's label
   */
  gaImpressionLabel: PropTypes.string,

  /**
   * The engagement GA event's category
   */
  gaEngagementCategory: PropTypes.string,

  /**
   * The engagement GA event's action
   */
  gaEngagementAction: PropTypes.string,

  /**
   * The engagement GA event's label
   */
  gaEngagementLabel: PropTypes.string,

  /**
   * The hover GA event's category
   */
  gaHoverCategory: PropTypes.string,

  /**
   * The hover GA event's action
   */
  gaHoverAction: PropTypes.string,

  /**
   * The hover GA event's label
   */
  gaHoverLabel: PropTypes.string,

  /**
   * The engagement GA event's category
   */
  gaEngagementSecondaryCategory: PropTypes.string,

  /**
   * The engagement GA event's action
   */
  gaEngagementSecondaryAction: PropTypes.string,

  /**
   * The engagement GA event's label
   */
  gaEngagementSecondaryLabel: PropTypes.string,

  /**
   * The hover GA event's category
   */
  gaHoverSecondaryCategory: PropTypes.string,

  /**
   * The hover GA event's action
   */
  gaHoverSecondaryAction: PropTypes.string,

  /**
   * The hover GA event's label
   */
  gaHoverSecondaryLabel: PropTypes.string,

  /**
   * The close GA event's category
   */
  gaCloseCategory: PropTypes.string,

  /**
   * The close GA event's action
   */
  gaCloseAction: PropTypes.string,

  /**
   * The close GA event's label
   */
  gaCloseLabel: PropTypes.string
} : {};
UpsellWrapper.defaultProps = {
  actionButton: null,
  actionButtonType: 'primary',
  adTagImage: {
    alt: '',
    src: ''
  },
  actionLink: null,
  actionText: 'Click',
  actionType: null,
  secondaryActionButton: null,
  secondaryActionButtonType: 'primary',
  secondaryActionLink: null,
  secondaryActionText: '',
  secondaryActionType: null,
  background: 'backgroundWhite',
  bodyMarkdownText: null,
  closeable: false,
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {},
  headingMarkdownText: null,
  icon: null,
  iconFontColor: '',
  media: {
    alt: '',
    src: ''
  },
  mediaQuery: {
    xs: {
      showBody: false
    },
    md: {
      showBody: true
    }
  },
  imageSize: 'lg',
  onAction: function onAction() {},
  onSecondaryAction: function onSecondaryAction() {},
  onClose: function onClose() {},
  showBody: true,
  showAdvertisement: false,
  tagInput: 'ADVERTISEMENT',
  overrideMargin: null,
  hasBorder: true,
  gaImpressionCategory: null,
  gaImpressionAction: 'display',
  gaImpressionLabel: null,
  gaEngagementCategory: null,
  gaEngagementAction: 'click',
  gaEngagementLabel: null,
  gaHoverCategory: null,
  gaHoverAction: 'hover',
  gaHoverLabel: null,
  gaEngagementSecondaryCategory: null,
  gaEngagementSecondaryAction: 'secondary CTA click',
  gaEngagementSecondaryLabel: null,
  gaHoverSecondaryCategory: null,
  gaHoverSecondaryAction: 'secondary CTA hover',
  gaHoverSecondaryLabel: null,
  gaCloseCategory: null,
  gaCloseAction: 'close',
  gaCloseLabel: null
};
/** @component styled-guidist */

export default UpsellWrapper;
export { UpsellWrapper };